export const THEMES = {
  light: {
    active: true,
    name: 'light',
  },
  highlight: {
    active: false,
    name: 'highlight',
  },
  dark: {
    active: true,
    name: 'dark',
  },
};

export const DEFAULT_THEME = THEMES.light.name;

export const DEV_THEME_PICKER_COOKIE = 'stashWebRegTheme';
